import styled from "styled-components";
import { px2rem } from "../../../../../utils/css";
export const NameWrapper = styled.div `
	line-height: ${px2rem(16)};
	font-size: ${px2rem(12)};
	color: #333333;
`;
export const OneLineName = styled.div `
	margin-bottom: 3px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
export const TwoLineName = styled.div `
	height: ${px2rem(38)};
	line-height: ${px2rem(19)};
	word-break: break-all;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
`;
export const ActiveImg = styled.img `
	height: ${px2rem(16)};
`;
